export const requestJson = async (url, options = {}) => {
  const bodyIsFormData = typeof FormData !== 'undefined' && options.body instanceof FormData

  const response = await fetch(url, {
    credentials: 'same-origin',
    ...options,
    headers: {
      Accept: 'application/json',
      ...(options.body && !bodyIsFormData ? { 'Content-Type': 'application/json' } : {}),
      ...csrfHeader(),
      ...(options.headers || {})
    }
  })

  const data = await response.json().catch(() => ({}))

  if (!response.ok) throw data

  return data
}

export const normalizeErrors = (error) => {
  if (Array.isArray(error?.errors)) return error.errors
  if (typeof error?.error === 'string') return [error.error]
  if (typeof error === 'string') return [error]

  return ['The request could not be completed.']
}

export const compactObject = (object) => Object.fromEntries(
  Object.entries(object).filter(([, value]) => value !== '' && value !== null && value !== undefined)
)

const csrfHeader = () => {
  const token = document.querySelector('meta[name="csrf-token"]')?.content

  return token ? { 'X-CSRF-Token': token } : {}
}
